import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Help from '../../Common/Help';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';

import './style.scss';
import Icon from "../../Common/Icon";
import {ReactComponent as CheckBoxIcon} from "../../../../img/form-checkbox-on.svg";
import {ReactComponent as CheckBoxDisabledIcon} from "../../../../img/form-checkbox-disabled.svg";

class Checkbox extends React.PureComponent {
  handleCLick = (e) => {
    const { onClick, disabled } = this.props;
    if (disabled) return;
    if (onClick) onClick(e);
    this.handleChange(e);
  };

  handleChange = (event) => {
    const { onChange, checked, disabled } = this.props;
    if (disabled) return;
    if (onChange) onChange(!checked);
    if (event && (!this.props.istag)) {
      $(event.target).closest('.InputCheckbox').find('.InputCheckbox_Input').trigger('focus');
    }
  };

  handleKeyPress = (event) => {
    if(event.key === 'Enter'){
      this.handleChange(event);
    }
  };

  render() {
    const {
      className,
      label,
      disabled,
      checked,
      help,
    } = this.props;

    let color = null;
    if (Boolean(disabled)) {
      color = 'tertiaryColor';
    }
    else {
      color = (Boolean(checked) ? 'secondaryColor' : 'white');
    }
    let colorHover = null;
    if (Boolean(disabled)) {
      colorHover = (Boolean(checked) ? 'tertiaryColor' : 'white');
    }
    else {
      colorHover = 'secondaryColor';
    }

    return (
      <div className={ classNames('InputCheckbox Relative', className) }>
        <input
          { ...this.props }
          checked={ Boolean(checked) }
          disabled={ disabled }
          onChange={ this.handleChange }
          type='checkbox'
          className={ classNames('InputCheckbox_Input', {
            InputCheckbox_Disabled: Boolean(disabled),
          }) }
          onKeyPress={ this.handleKeyPress }
        />
        <Icon className='Relative' width='15' height='15' color={ color }
              changeColor='secondaryColor' hoverColor={ colorHover }>
          <div  onClick={ this.handleCLick }>
            { disabled && !checked &&
            <CheckBoxDisabledIcon alt='checkbox-disabled'/>
            ||
            <CheckBoxIcon alt='checkbox-checked'/>
          }</div>
        </Icon>
        <div className={ classNames('InputCheckbox_Label', {
               InputCheckbox_Label_Help: Boolean(help),
             }) }>
          { label }
        </div>
        { help && (
          <Help
            message={ help }
            className='Tooltip_Top'
          />
        ) }
      </div>
    );
  }
}

Checkbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
};

export default withShallowComparison(Checkbox, ['onChange', 'onError']);